import type { Auth } from 'firebase/auth';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
};

export const firebaseEnabled = Boolean(config.apiKey && config.projectId);

let authPromise: Promise<Auth> | null = null;

/** Firebase is loaded lazily so the till starts fast and works without it. */
export function getFirebaseAuth(): Promise<Auth> {
  if (!firebaseEnabled) return Promise.reject(new Error('Firebase is not configured'));
  authPromise ??= (async () => {
    const [{ initializeApp }, { getAuth, browserLocalPersistence, setPersistence }] = await Promise.all([
      import('firebase/app'),
      import('firebase/auth'),
    ]);
    const auth = getAuth(initializeApp(config));
    await setPersistence(auth, browserLocalPersistence);
    return auth;
  })();
  return authPromise;
}

export async function firebaseIdToken(): Promise<string | null> {
  if (!firebaseEnabled) return null;
  const auth = await getFirebaseAuth();
  await auth.authStateReady();
  return auth.currentUser ? auth.currentUser.getIdToken() : null;
}
